import { z } from 'zod';

// Story 6.11 — DLQ admin response schemas

export const dlqItemSchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  clientName: z.string(),
  direction: z.string(),
  channel: z.string(),
  templateKey: z.string().nullable(),
  attemptsCount: z.number().int(),
  errorMessage: z.string().nullable(),
  failedAt: z.coerce.date().nullable(),
  relatedChargeId: z.string().uuid().nullable(),
  metadata: z.unknown(),
});

export const dlqListResponseSchema = z.object({
  data: z.array(dlqItemSchema),
  pagination: z.object({
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
  }),
});

export const dlqRetryResponseSchema = z.object({
  data: z.object({
    id: z.string().uuid(),
    requeued: z.literal(true),
    jobId: z.string(),
  }),
});

export type DlqItem = z.output<typeof dlqItemSchema>;
export type DlqListResponse = z.output<typeof dlqListResponseSchema>;
export type DlqRetryResponse = z.output<typeof dlqRetryResponseSchema>;
